<div class="estimacion-details">
  <div class="form-row full-width">
    <label>Nombre del Proyecto:</label>
    <input class="form-control" [(ngModel)]="estimation.name" (change)="onEstimationChange()" />
  </div>

  <div class="form-row">
    <label>Fecha:</label>
    <input class="form-control" type="date" [(ngModel)]="estimation.createdate" (change)="onEstimationChange()" />
  </div>

  <div class="form-row">
    <label>Sociedad:</label>
    <select class="form-control" [(ngModel)]="selectedSociety" (change)="onSocietyChange()" [compareWith]="compareSocieties">
      <option *ngFor="let society of societies" [ngValue]="society">{{ society.name }}</option>
    </select>
  </div>

  <!-- NUEVO 1a: multi-select de sistemas, filtrado por cliente derivado de sociedad -->
  <div class="form-row">
    <label>Sistemas:</label>
    <app-multi-select
        [items]="filteredSystems"
        [selected]="estimation.systems || []"
        [displayField]="'name'"
        [trackBy]="'id'"
        [placeholder]="selectedSociety.client?.id ? 'Seleccionar sistemas...' : 'Selecciona primero una sociedad'"
        [disabled]="!selectedSociety.client?.id"
        (selectionChange)="onSystemsChange($event)">
    </app-multi-select>
  </div>

  <div class="form-row">
    <label>Departamento:</label>
    <select class="form-control" [(ngModel)]="estimation.project.department" (change)="onDepartmentChange()" [compareWith]="compareDepartments">
      <option *ngFor="let department of departments" [ngValue]="department">{{ department.name }}</option>
    </select>
  </div>

  <div class="form-row">
    <label>Tipo:</label>
    <select class="form-control" [(ngModel)]="estimation.project.type" (change)="onEstimationChange()" [compareWith]="compareTypes">
      <option *ngFor="let type of types" [ngValue]="type">{{ type.name }}</option>
    </select>
  </div>
</div>